import { IPaymentFormData } from 'common/types/tips.types';

/* Скрытые поля формы: все поля ответа start, кроме адреса; null уходит пустой строкой, как его отправлял
 *  прежний рендер. Своих полей страница не добавляет ни к одной форме: язык и маршрут держит бэк
 *  (payment-method-rename, R-3, R-4). */
export const getHiddenFields = (data: IPaymentFormData): [string, string][] =>
  Object.entries(data)
    .filter(([key]) => key !== 'Url')
    .map(([key, value]) => [key, value === null || value === undefined ? '' : String(value)]);
